<template>
  <div class="sms text-dark no-print text-dark">
    <div class="sms-header__toggler" v-if="!isOpen" @click="setOpen(!isOpen)">
      <h4>{{ i18n[locale]['send_message'] }}</h4>
      <div class="close-icon sms-header__toggler__icon text-white">
        <span class="icon-cross2" v-if="isOpen"></span>
        <span class="icon-arrow-up4" v-else></span>
      </div>
    </div>
    <transition name="slideInUp" @after-enter="onEnterComplete">
      <div class="sms-container" v-if="isOpen">
        <div class="sms-header__toggler" @click="isOpen = !isOpen">
          <h4>{{ i18n[locale]['send_message'] }}</h4>
          <div class="close-icon sms-header__toggler__icon text-white">
            <span class="icon-cross2" v-if="isOpen"></span>
            <span class="icon-arrow-up4" v-else></span>
          </div>
        </div>
        <div class="sms-body">
          <transition name="fadeOut">
            <div class="sms-body__signup" v-if="noNumberForUser">
              <transition name="fade">
                <div class="sms-body__signup__content box">
                  <h2 class="text-blue">{{ i18n[locale]['welcome_to_sms'] }}</h2>
                  <p class="marg-10-bottom">{{ i18n[locale]['add_your_number_to_send_sms'] }}</p>
                  <label>{{ i18n[locale]['add_your_number'] }}</label>
                  {{ user.phone }}
                  <SmsAddNumber
                    :userid="user.id"
                    :updateThisUser="true"
                    :isEditFromStart="true"
                    class="marg-10-right">
                  </SmsAddNumber>
                </div>
              </transition>
            </div>
          </transition>
          <div class="select-users">
            <div class="users-header-second users-header-second__button">
              <button class="do-bttn do-bttn--small" @click="getSubsOfTheDay">
                {{ i18n[locale]['todays_substitutes'] }}
              </button>
              <DoFiltersFilter
                :title="''"
                :tags="tags"
                :selectedTags="appliedFilters"
                @select="toggleTag"
                @clear="clearAllTags">
              </DoFiltersFilter>
              <input type="text"
                     class="users-header__searchfield"
                     v-model="searchText"
                     :placeholder="$t('vue2.common.search')">
            </div>
            <div class="list">
              <ul class="users-list">
                <li class="users-user users-user__header">
                  <p class="text-link" v-if="selectedUsers.length < 1" @click="setAllUsersSelected">
                    {{ $t('vue2.tagging.select_all') }}
                  </p>
                  <p class="text-link" v-else @click="removeAllSelectedUsers">
                    {{ $t('vue2.tagging.unselect_all') }}
                  </p>
                  <div class="users-user users-user__header__right">
                    <p class="last-sms-text last-sms-text--click" @click="toggleSortByLast">
                      {{ i18n[locale].last_sms }}
                      <span v-if="sortMode === 'name'" class="icon-menu-open"></span>
                      <span v-if="sortMode === 'last'">▲</span>
                    </p>
                    <p v-if="isSMSActive">{{ i18n[locale]['sms'] }}</p>
                    <p v-if="isEmailActive">{{ i18n[locale]['email'] }}</p>
                  </div>
                </li>
                <Loader v-if="isLoading" bg-color="#fff"></Loader>
                <template v-if="!isLoading">
                  <p class="pad-20" v-if="filteredUsers.length < 1"><i>{{ i18n[locale]['no_users_matches'] }}</i></p>
                  <li v-for="(user, idx) in filteredUsers"
                      :key="user.id"
                      :ref="'user_ '+ user.id"
                      class="users-user"
                      :class="[
                        {'users-user--only': filteredUsers.length === 1},
                {'isSelected': checkIfInList(user.id)},
                {'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'},
                {'selectedWithoutContactForm': checkIfInListWithoutContactForm(user.id)}]">
                    <div class="users-user__meta" @click="setUser(user, idx, $event)">
                      <div class="users-choose"
                           :class="{'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'}">
                        <div class="checkbox" :class="{'checkboxChecked': checkIfInList(user)}">
                          <span class="checked"></span>
                        </div>
                      </div>
                      <div class="users-img">
                        <img :src="user.img" alt=""/>
                      </div>
                      <div class="users-name">
                        <p>{{ user.name }}</p>
                        <div class="users__last-message"
                             :content="i18n[locale]['see_message']"
                             v-tippy="{
                               arrow: true,
                               placement : 'top'
                             }"
                             @click.stop="showSent(user)" v-if="user.v_last_sms_at">
                            {{ user.v_last_sms_at_human }}
                        </div>
                      </div>
                    </div>
                    <div class="users-last">
                      <div class="contact-options">
                        <div class="contact-options__option"
                             v-if="isSMSActive"
                             :class="{'contact-options__option--disabled': user.v_phone_setting === 'deactivated'}">
                          <div class="icon__bg-circle contact-options__option__phone"
                               @click="setOption(user, 'phone')"
                               :content="user.v_phone_tooltip"
                               v-tippy="{
                               arrow: true
                             }">
                            <svg v-if="user.v_phone_setting === 'no_number'" xmlns="http://www.w3.org/2000/svg"
                                 fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                 class="d-hero-icon--add w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
                            </svg>
                            <svg v-if="user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated'"
                                 :class="{'d-tw-icon--deactivated': user.v_phone_setting === 'deactivated'}"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                 stroke="currentColor" class="d-hero-icon w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"/>
                            </svg>
                            <svg v-if="user.v_phone_setting === 'awaiting_approval'" xmlns="http://www.w3.org/2000/svg"
                                 fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                 stroke="currentColor" class="w-6 h-6 d-icon__awaiting-approval d-hero-icon">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/>
                            </svg>
                          </div>
                        </div>
                        <div class="contact-options__option"
                             v-if="isEmailActive"
                             :class="{'contact-options__option--disabled': user.v_email_setting === 'deactivated'}">
                          <div class="icon__bg-circle"
                               @click="setOption(user, 'email')"
                               :content="user.v_email_tooltip"
                               v-tippy="{
                               arrow: true
                             }">
                            <svg v-if="user.v_email_setting === 'no_email'" xmlns="http://www.w3.org/2000/svg"
                                 fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                 class="d-hero-icon--add w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
                            </svg>
                            <svg v-if="user.v_email_setting === 'active' || user.v_email_setting === 'deactivated'"
                                 :class="{'d-tw-icon--deactivated': user.v_email_setting === 'deactivated'}"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                 stroke="currentColor" class="w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>
                            </svg>
                          </div>
                        </div>
                        <div class="contact-options__option contact-options__option__settings">
                          <div class="icon__bg-circle icon-more2" @click="theActiveEditUser = user"></div>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="send-sms">
            <div class="users-header-second">
              <h2>{{ i18n[locale]['send_message_to'] }} {{ selectedUsers.length }}</h2>
            </div>
            <div class="send-sms__body">
              <div class="send-sms__body__templates">
                <label>{{ i18n[locale]['select_a_standard_template'] }}</label>
                <div v-if="isLoadingTemplates">
                  <spinner :isSmall="true"></spinner>
                </div>
                <div v-else class="standard-sms flex" v-for="template in templates" :key="template.id">
                  <div class="standard-sms__sub sms-template">
                    <div class="sms-template__title" @click="selectTemplate(template)">
                      <span class="icon-file-text"></span>
                      <p>{{ template.title }}</p>
                    </div>
                    <d-dropdown>
                      <ul slot="list">
                        <li @click.self="setTheEditTemplate(template)">{{ $t('vue2.common.edit') }}</li>
                        <li class="d-item-warning" @click.self="theDeleteTemplate = template">
                          {{ $t('vue2.common.delete') }}
                        </li>
                      </ul>
                    </d-dropdown>
                  </div>
                </div>
                <div class="standard-sms flex">
                  <div class="standard-sms__sub sms-template sms-template__create" @click="isCreateTemplate = true">
                    <div class="sms-template__title">
                      <span>+</span>
                      <p> {{ i18n[locale]['create_a_standard_template'] }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="send-sms__body__message">
                <label>{{ i18n[locale]['message'] }}</label>
                <input type="text" v-model="messageSubject" :placeholder="i18n[locale]['subject']"/>
                <textarea v-model="messageBody"
                          :placeholder="i18n[locale]['message']"
                          @click="giveFeedback = false"
                          ref="sms"
                          class="marg-1-bottom marg-1-top"
                          :class="{'error-class': giveFeedback && noText}"></textarea>
                <span class="error-text" v-if="giveFeedback && noText">{{
                    i18n[locale]['message_must_be_filled']
                  }}</span>
                <button class="submit-button width-100 submit-button--disabled" v-if="noText || noReceiver"
                        @click="giveFeedback = true">{{ i18n[locale]['send_message'] }}
                </button>
                <button class="submit-button width-100" @click="sendMessage" v-else>{{
                    i18n[locale]['send_message']
                  }}
                </button>
              </div>
              <div class="send-sms__body__receivers marg-1-left marg-1-right">
                <label>{{ i18n[locale]['recipients'] }}</label>
                <p class="explainer-text" v-if="selectedUsers.length < 1">
                  {{ i18n[locale]['select_recipients'] }}</p>
                <ul class="receivers-container">
                  <li class="receivers-container__receiver" v-for="user in userSetSelected">
                    <div class="receiver__name">{{ user.name }}</div>
                    <div class="receiver__remove icon-cross2" @click="setUser(user, idx)"></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <TemplateModal v-if="isCreateTemplate"
                   :editsms="theEditTemplate"
                   messageType="email"
                   @close="closeTemplate"
                   @updated="readMessageTemplates">
    </TemplateModal>
    <TemplateDelete v-if="theDeleteTemplate"
                    :editsms="theDeleteTemplate"
                    @close="theDeleteTemplate = null"
                    @updated="readMessageTemplates">
    </TemplateDelete>
    <SendMessagesUserSetting
      v-if="theActiveEditUser"
      :user="theActiveEditUser"
      :isEmailActive="isEmailActive"
      :isSMSActive="isSMSActive"
      @close="closeUserSetting">
    </SendMessagesUserSetting>
    <SendMessagesPastSmses
      v-if="isShowPastSMSes"
      :activeUser="pastSmsModalUser"
      :sms="pastSmsModalData"
      @close="isShowPastSMSes = false">
    </SendMessagesPastSmses>
    <div class="bg-overlay" v-if="theActiveEditUser"></div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import SmsAddNumber from './SmsAddNumber'
import TemplateModal from './MessageTemplate'
import TemplateDelete from './MedssageTemplateDelete'
import moment from 'moment'
import DDropdown from '../common/DDropdown'
import Spinner from '../common/Loader'
import SendMessagesUserSetting from './SendMessagesUserSetting'
import Loader from '../common/Loader.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import TaggingFilter from '../Tagging/TaggingFilter.vue'
import DoFilters from '../DoFilters/DoFilters.vue'
import SendMessagesPastSmses from './SendMessagesPastSmses.vue'

const I18N = {
  da: {
    send_message: 'Send besked',
    recipient: 'Modtager',
    a_recipient: 'Vælg en modtager',
    subject: 'Emnefelt',
    message: 'Besked',
    message_must_be_filled: 'Besked skal udfyldes',
    sending_message: 'Sender besked',
    message_sent: 'Besked sendt',
    no_users_matches: 'Ingen brugere matcher din søgning',
    todays_substitutes: 'Vælg dagens vikarer',
    send_message_to: 'Send besked til',
    select_a_standard_template: 'Vælg en besked',
    create_a_standard_template: 'Opret ny standard besked',
    recipients: 'Modtagere',
    select_recipients: 'Vælg modtagere fra listen til venstre',
    deactivate_sms: 'Slå SMS fra',
    activate_sms: 'Slå SMS til',
    deactivate_email: 'Slå email fra',
    activate_email: 'Slå email til',
    add_number: 'Tilføj nummer',
    add_email: 'Tilføj email',
    awaiting_approval: 'Afventer bekræftelse',
    sms: 'SMS',
    email: 'email',
    settings: 'Indstillinger',
    email_sent: 'Emails afsendt',
    sms_sent: 'SMSer afsendt',
    welcome_to_sms: 'Velkommen til SMS',
    add_your_number_to_send_sms: 'Indtast dit mobilnummer for at begynde at sende smser til skolens personale. Modtagere kan besvare til dette nummer.',
    add_your_number: 'Tilføj dit mobilnummer',
    last_sms: 'Sidst sendt til',
    see_message: 'Se besked'
  },
  nb: {
    send_message: 'Send melding',
    recipient: 'Velg mottaker',
    a_recipient: 'Velg en mottaker',
    subject: 'Emnefelt',
    message: 'Melding',
    message_must_be_filled: 'Meldingsfelt må utfylles',
    sending_message: 'Sender melding',
    message_sent: 'Melding sendt',
    no_users_matches: 'Ingen brukere passer til søket',
    todays_substitutes: 'Dagens vikarer',
    send_message_to: 'Send melding til',
    select_a_standard_template: 'Velg en melding',
    create_a_standard_sms: 'Opprett ny standardmelding',
    recipients: 'Mottakere',
    select_recipients: 'Velg mottakere fra listen til venstre',
    deactivate_sms: 'Deaktivere SMS',
    activate_sms: 'Aktivere SMS',
    deactivate_email: 'Deaktivere e-post',
    activate_email: 'Aktivere e-post',
    add_number: 'Legg til nummer',
    add_email: 'Legg til e-post',
    awaiting_approval: 'Venter på bekreftelse',
    sms: 'SMS',
    email: 'e-post',
    settings: 'Innstillinger',
    email_sent: 'E-poster sendt',
    sms_sent: 'SMS sendt',
    last_sms: 'Sist sendt til',
    see_message: 'Se melding'
  },
  en: {
    send_message: 'Send message',
    recipient: 'Recipient',
    a_recipient: 'Choose a recipient',
    subject: 'Subject',
    message: 'Message',
    message_must_be_filled: 'Message can not be empty',
    sending_message: 'Sending message',
    message_sent: 'Message sent',
    no_users_matches: 'No matching users',
    todays_substitutes: 'Substitutes today',
    send_message_to: 'Send message to',
    select_a_standard_template: 'Choose a template',
    create_a_standard_template: 'Create new template',
    recipients: 'Recipients',
    select_recipients: 'Choose users to receive the message',
    deactivate_sms: 'Deactivate SMS',
    activate_sms: 'Activate SMS',
    deactivate_email: 'Deactivate email',
    activate_email: 'Activate email',
    add_number: 'Add number',
    add_email: 'Add email',
    awaiting_approval: 'Awaiting approval',
    sms: 'SMS',
    email: 'email',
    settings: 'Settings',
    email_sent: 'Emails sent',
    sms_sent: 'SMS sent',
    last_sms: 'Last sent to',
    see_message: 'See message'
  }
}

export default {
  components: {
    SendMessagesPastSmses,
    DoFilters,
    TaggingFilter,
    DoFiltersFilter,
    Loader, SendMessagesUserSetting, DDropdown, SmsAddNumber, TemplateModal, TemplateDelete, Spinner
  },
  data () {
    return {
      pastSmsModalUser: null,
      pastSmsModalData: null,
      sortMode: 'name', // 'name' | 'last'
      pastSmsesMap: {},
      isEmailActive: true,
      isSMSActive: false,
      isOpen: false,
      selectedWithoutContactForm: [],
      selectedUser: '',
      messageSubject: '',
      messageBody: '',
      giveFeedback: false,
      selectedUsers: [],
      searchText: '',
      appliedFilters: [],
      tags: [],
      isCreateTemplate: false,
      theEditTemplate: null,
      theDeleteTemplate: null,
      isLoadingTemplates: true,
      templates: [],
      theActiveEditUser: null,
      isEmailSent: true,
      isSMSSent: true,
      isLoading: true,
      isInitialLoad: true,
      isShowPastSMSes: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    activeDate () {
      return this.$store.state.subs.date
    },
    noNumberForUser () {
      return this.user && !this.user.phone
    },
    i18n () {
      return I18N
    },
    usersToReceiveEmail () {
      const users = this.userSetSelected.filter(user => user.v_email_setting === 'active')
      return users.map(user => user.id)
    },
    usersToReceiveSMS () {
      const users = this.userSetSelected.filter(user => user.v_phone_setting === 'active')
      return users.map(user => user.id)
    },
    userSetSelected () {
      const usersMap = this.usersWithCustomProps.reduce((acc, user) => {
        acc[user.id] = user
        return acc
      }, {})

      return this.selectedUsers
        .filter(id => usersMap[id])
        .map(id => usersMap[id])
    },
    locale () {
      return this.$store.getters.locale
    },
    usersSortedOnName () {
      return this.$store.getters.usersSortedOnName
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    noText () {
      return this.messageBody.length < 1 || this.messageSubject.length < 1
    },
    noReceiver () {
      return this.selectedUsers.length < 1
    },
    usersUrl () {
      return '/schools/' + this.schoolId + '/users'
    },
    usersWithCustomProps () {
      return this.usersSortedOnName.map(user => {
        const vPhoneSetting = this.getContactOption(user, 'phone')
        const vEmailSetting = this.getContactOption(user, 'email')

        const lastRow = this.pastSmsesMap[user.id]
        const lastTs = lastRow ? lastRow.created_at : null
        const lastHuman = lastTs ? this.formatLastSmsHuman(lastTs) : null
        const lastRelative = lastTs ? this.formatLastSmsRelative(lastTs) : null

        return {
          ...user,
          v_phone_setting: vPhoneSetting,
          v_phone_tooltip: this.getTooltipText('sms', vPhoneSetting),
          v_email_setting: vEmailSetting,
          v_email_tooltip: this.getTooltipText('email', vEmailSetting),
          v_last_sms_row: lastRow,               // hele raden (id, message, phone, created_at, ...)
          v_last_sms_at: lastTs,                 // ISO timestamp
          v_last_sms_at_human: lastHuman,
          v_last_sms_relative: lastRelative
        }
      })
    },
    searchedUsers () {
      return this.usersWithCustomProps.filter(user => {
        return user.name !== '' ? user.name.match(new RegExp(this.searchText, 'i')) : ''
      })
    },
    filteredUsers () {
      let passedUsers = this.searchedUsers
      if (this.appliedFilters.length > 0) {
        passedUsers = passedUsers.filter(user => user.user_tags.some(tag => this.appliedFilters.includes(tag)))
      }

      const collator = new Intl.Collator(this.locale || 'da-DK', { sensitivity: 'base', numeric: true })

      return passedUsers.slice().sort((a, b) => {
        if (this.sortMode === 'last') {
          const aTs = a.v_last_sms_at || null
          const bTs = b.v_last_sms_at || null

          if (aTs && !bTs) return -1
          if (!aTs && bTs) return 1

          if (aTs && bTs) {
            const aTime = moment(aTs).valueOf()
            const bTime = moment(bTs).valueOf()
            if (aTime !== bTime) return bTime - aTime
          }

          return collator.compare(a.name || '', b.name || '')
        }

        // default: navn A→Å, tie-breaker: senest sendt først
        const nameCmp = collator.compare(a.name || '', b.name || '')
        if (nameCmp !== 0) return nameCmp

        const aTime = a.v_last_sms_at ? moment(a.v_last_sms_at).valueOf() : 0
        const bTime = b.v_last_sms_at ? moment(b.v_last_sms_at).valueOf() : 0
        return bTime - aTime
      })
    },
    absentUsersFromUserSet () {
      return this.$store.getters.absentUsersFromUserSet
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    }
  },
  watch: {
    activeDate () {
      this.removeAllSelectedUsers()
    }
  },
  methods: {
    showSent (user) {
      const row = user && user.v_last_sms_row ? user.v_last_sms_row : null
      this.pastSmsModalUser = user
      this.pastSmsModalData = row
      this.isShowPastSMSes = true
      this.$store.dispatch('trackEvent', 'substitution_SMS_showLastSentMessage')
    },
    toggleSortByLast () {
      this.sortMode = this.sortMode === 'last' ? 'name' : 'last'
      this.$store.dispatch('trackEvent', 'substitution_SMS_sortedBySent')
    },
    readPastSMSes () {
      docendo.pastSmses(this.schoolId, success => {
        const rows = success && success.data ? success.data : []
        const byUser = {}

        for (let i = 0; i < rows.length; i++) {
          const row = rows[i]
          const uid = row.user_id
          if (!byUser[uid]) {
            byUser[uid] = row
          } else {
            const newer = moment(row.created_at).isAfter(moment(byUser[uid].created_at))
            if (newer) byUser[uid] = row
          }
        }

        this.pastSmsesMap = byUser
      }, failure => {
        console.log({ failure })
      })
    },
    // helper hvis du vil genbruge formateringen andre steder
    formatLastSmsHuman (ts) {
      if (!ts) return ''
      // Sæt evt. locale hvis du bruger flere sprog i UI'et
      // moment.locale(this.locale)
      return moment(ts).format('lll')
    },
    formatLastSmsRelative (ts) {
      if (!ts) return ''
      return moment(ts).fromNow()
    },
    toggleTag (tag) {
      const idx = this.appliedFilters.indexOf(tag)
      if (idx > -1) {
        this.appliedFilters.splice(idx, 1)
      } else {
        this.appliedFilters.push(tag)
      }
    },
    clearAllTags () {
      this.appliedFilters = []
      this.removeAllSelectedUsers()
    },
    setOpen (bool) {
      if (bool) {
        this.isLoading = true
        this.isOpen = true
        if (this.isInitialLoad) {
          this.readTags()
          this.$store.dispatch('getUsers')
          this.readPastSMSes()
          this.readMessageTemplates()
        }
        this.isInitialLoad = false
      } else {
        this.isOpen = false
      }
    },
    onEnterComplete () {
      this.isLoading = false
    },
    getTooltipText (contactType, setting) {
      const tooltips = {
        active: this.i18n[this.locale][`deactivate_${contactType}`],
        no_number: this.i18n[this.locale]['add_number'],
        no_email: this.i18n[this.locale]['add_email'],
        awaiting_approval: this.i18n[this.locale]['awaiting_approval'],
        deactivated: this.i18n[this.locale][`activate_${contactType}`]
      }
      return tooltips[setting]
    },
    setOption (user, contactType) {
      const currentSetting = this.getContactOption(user, contactType)
      const needsEdit = (contactType === 'phone' && currentSetting === 'no_number') ||
        (contactType === 'email' && currentSetting === 'no_email') ||
        currentSetting === 'awaiting_approval'

      if (needsEdit) {
        this.theActiveEditUser = user
        return
      }

      if (['active', 'deactivated'].includes(currentSetting)) {
        this.updateUserSettings(user, contactType)
      }
    },

    getContactOption (user, contactType) {
      if (contactType === 'phone' && !this.isSMSActive) return 'no_number'
      if (contactType === 'email' && !this.isEmailActive) return 'no_email'

      const hasContact = user[contactType]
      if (!hasContact) return contactType === 'phone' ? 'no_number' : 'no_email'

      if (contactType === 'phone' && user.unconfirmed_phone) return 'awaiting_approval'

      const userSettings = JSON.parse(user.settings)
      if (userSettings[`dont_receive_${contactType}`]) return 'deactivated'

      return 'active'
    },
    closeUserSetting () {
      const user = this.allUsersInHash[this.theActiveEditUser.id]
      const emailSetting = this.getContactOption(user, 'email')
      const phoneSetting = this.getContactOption(user, 'phone')
      if (emailSetting === 'active' || phoneSetting === 'active') {
        const idx2 = this.selectedWithoutContactForm.indexOf(user.id)
        if (idx2 > -1) {
          this.selectedWithoutContactForm.splice(idx2, 1)
        }
      } else {
        const idx = this.selectedUsers.indexOf(user.id)
        if (idx > -1) {
          this.selectedUsers.splice(idx, 1)
        }
      }
      this.theActiveEditUser = null
    },
    updateUserSettings (user, contactType) {
      const idx = this.selectedWithoutContactForm.indexOf(user.id)
      if (idx > -1) {
        this.selectedWithoutContactForm.splice(idx, 1)
      }
      const idx2 = this.selectedUsers.indexOf(user.id)
      if (idx2 > -1) {
        this.selectedUsers.splice(idx2, 1)
      }
      const userSettings = JSON.parse(user.settings)
      const varOption = 'dont_receive_' + contactType
      let settingsObj = {}
      settingsObj[varOption] = true
      const prop = Object.keys(settingsObj)[0]
      if (this.getContactOption(user, contactType) === 'deactivated') {
        delete userSettings[prop]
      } else {
        const val = settingsObj[prop]
        userSettings[prop] = val
      }
      const changes = {settings: JSON.stringify(userSettings)}
      docendo.updateUsers(this.schoolId, user.id, changes, data => {
        this.$store.commit('updateSchoolUser', data)
      }, failure => {
        console.log('failure')
      })
    },
    setTheEditTemplate (template) {
      this.theEditTemplate = template
      this.isCreateTemplate = true
    },
    createNewTemplate () {
      this.isCreateTemplate = true
    },
    closeTemplate () {
      this.theEditTemplate = null
      this.theDeleteTemplate = null
      this.isCreateTemplate = false
    },
    selectTemplate (template) {
      const today = moment().format('dddd')
      this.messageSubject = template.title.replace('[today]', today)
      this.messageBody = template.body.replace('[today]', today)
    },
    getSubsOfTheDay () {
      // Map fra user_calendar_id -> user, så vi kan finde brugeren bag et sub-event
      const userMap = this.usersWithCustomProps.reduce((acc, user) => {
        acc[user.user_calendar_id] = user
        return acc
      }, {})

      // Vi kigger kun på dagens dato
      const today = moment(this.activeDate).format('YYYY-MM-DD')

      // allEventsInAHash antages at indeholde alle dagens events i et hash { id: eventObj }
      const eventsHash = this.allEventsInAHash || {}
      const events = Object.keys(eventsHash).map(id => eventsHash[id])

      events.forEach(lesson => {
        if (!lesson) return
        if (lesson.v_is_event_from_other_school) return

        // Tjek at lektionen er i dag
        const lessonDay = moment(lesson.start).format('YYYY-MM-DD')
        if (lessonDay !== today) return

        // Find alle sub-events på lektionen (uanset om der er registreret fravær)
        const calEvents = lesson.calendar_events || []
        const subEvents = calEvents.filter(e => e.substitute || e.is_substitute)

        subEvents.forEach(subEvent => {
          const subUser = userMap[subEvent.calendar_id]
          if (subUser) this.setSub(subUser)
        })
      })
    },
    getUserLessons (user) {
      const lessons = user.dayEvents.map(eventId => this.allEventsInAHash[eventId])
      lessons.filter(lesson => !lesson.v_is_event_from_other_school).forEach(lesson => {
        this.getSubsFromLessons(lesson)
      })
    },
    getSubsFromLessons (lesson) {
      const subEvents = lesson.calendar_events.filter(event => event.substitute || event.is_substitute)

      // Omdanner usersWithCustomProps til et opslag for hurtigere adgang
      const userMap = this.usersWithCustomProps.reduce((acc, user) => {
        acc[user.user_calendar_id] = user
        return acc
      }, {})

      subEvents.forEach(subEvent => {
        const sub = userMap[subEvent.calendar_id]
        if (sub) {
          this.setSub(sub)
        }
      })
    },
    setSub (user, $event) {
      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
        if (this.selectedUsers.indexOf(user.id) < 0) {
          this.selectedUsers.push(user.id)
        }
      } else {
        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
          this.selectedWithoutContactForm.push(user.id)
        }
      }
    },
    checkIfInListWithoutContactForm (userid) {
      return this.selectedWithoutContactForm.indexOf(userid) > -1
    },
    resetData () {
      this.selectedUsers = []
      this.selectedUser = ''
      this.messageSubject = ''
      this.messageBody = ''
    },
    sendMessage () {
      const usersToReceiveEmail = this.usersToReceiveEmail
      const usersToReceiveSMS = this.usersToReceiveSMS
      if (usersToReceiveEmail.length > 0) {
        this.isEmailSent = false
      }
      if (usersToReceiveSMS.length > 0) {
        this.isSMSSent = false
      }
      if (usersToReceiveEmail.length > 0) {
        this.sendEmails(usersToReceiveEmail)
      }
      if (usersToReceiveSMS.length > 0) {
        this.sendSMS(usersToReceiveSMS)
      }
    },
    sendEmails (userIds) {
      eventbus.toast = {text: this.i18n[this.locale]['sending_message'], 'success': false}
      this.isOpen = false
      docendo.sendEmails(this.schoolId, userIds, this.messageSubject, this.messageBody, success => {
        this.isEmailSent = true
        eventbus.toast = {text: this.i18n[this.locale]['email_sent'], 'success': true}
        if (this.isSMSSent) {
          this.resetData()
        }
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      })
    },
    sendSMS (userIds) {
      docendo.sendSmses(this.schoolId, userIds, this.messageBody, (data) => {
        this.isSMSSent = true
        eventbus.toast = {text: this.i18n[this.locale]['sms_sent'], 'success': true}
        if (this.isEmailSent) {
          this.resetData()
        }
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      })
    },
    removeAllSelectedUsers () {
      this.selectedUsers = []
      this.selectedWithoutContactForm = []
    },
    setUser (user, idx, $event) {
      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
        if (this.selectedUsers.indexOf(user.id) > -1) {
          this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1)
        } else {
          this.selectedUsers.push(user.id)
        }
      } else {
        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
          this.selectedWithoutContactForm.push(user.id)
        }
      }
    },
    setAllUsersSelected () {
      this.selectedUsers = []
      this.selectedWithoutContactForm = []
      for (let i = 0; i < this.filteredUsers.length; i++) {
        const user = this.filteredUsers[i]
        if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
          this.selectedUsers.push(user.id)
        }
      }
    },
    checkIfInList (userid) {
      return this.selectedUsers.indexOf(userid) > -1
    },
    readMessageTemplates () {
      this.closeTemplate()
      this.isLoadingTemplates = true
      this.templates = []
      docendo.readMessageTemplates(this.schoolId, messages => {
        this.templates = messages.filter(message => message.message_type === 'email')
        this.isLoadingTemplates = false
      }, failure => {
        console.log('failed')
      })
    },
    readTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    }
  },
  beforeMount () {
    const country = window.SCHOOL.country && window.SCHOOL.country.toLowerCase()
    if (country === 'dk' || country === 'no') {
      this.isSMSActive = true
    }
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.sms {
  position: fixed;
  right: 88px;
  z-index: 2;
  bottom: 0px;
}

.sms-header__toggler {
  position: absolute;
  right: 0;
  top: -46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--primary);
  padding: 1rem 0.75rem;
  border-radius: 4px 4px 0 0;
  width: 125px;
  box-shadow: 0 -5px 17px 2px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12), 0 5px 5px -3px rgba(0, 0, 0, .2);
  cursor: pointer;
}

.sms-header__toggler h4 {
  color: #fff;
}

.sms-header h2 {
  color: white;
}

.sms-body {
  display: flex;
  background-color: white;
  height: 70vh;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -5px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
  border: 1px solid #d8d8d8;
}

.sms-body__signup {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #edf0f5;
  z-index: 121212;
}

.sms-body__signup__content {
  width: 350px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 6px;
}

.sms-body.sms-body__old {
  display: block;
  padding: 20px;
  height: 300px;
}

.select-users {
  width: 500px;
}

.users-header {
  border-right: 1px solid #d8d8d8;
}

.send-sms > div:first-child {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #d8d8d8;
}

textarea.error-class,
select.error-class {
  border: 1px solid var(--danger);
}

.error-text {
  color: var(--danger);
  display: inherit;
}

.text--small {
  font-size: 0.9rem;
}

.send-sms {
  width: 300px;
}

.send-sms__body {
  height: calc(70vh - 50px);
  overflow-y: auto;
  margin-left: -1px;
  background: #edf0f5;
  border-left: 1px solid #d8d8d8;
}

.send-sms__body__message {
  padding: 1rem;
}

.send-sms__body__message input, .send-sms__body__message textarea {
  background-color: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
}

.send-sms__body__message > textarea {
  height: 120px;
}

.users-choose {
  width: 40px;
  padding-left: 20px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  font-size: 1rem;
  user-select: none;
}

.checkbox {
  position: absolute;
  top: 0;
  left: 20px;
  width: 18px;
  height: 18px;
  z-index: 0;
  border: 2px solid #5a5a5a;
  border-radius: 1px;
  margin-top: 3px;
  transition: .2s;
}

.users-user.isSelected .checkbox {
  top: -4px;
  left: 15px;
  width: 12px;
  height: 22px;
  border-top: 2px solid transparent;
  border-left: 2px solid transparent;
  border-right: 2px solid #26a69a;
  border-bottom: 2px solid #26a69a;
  transform: rotate(40deg);
  backface-visibility: hidden;
  transform-origin: 100% 100%;
}

.users-user--only {
  border-bottom: 1px solid #d8d8d8;
}

.users {
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background: #fff;
}

.users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #d8d8d8;
}

.users-header-second {
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  padding: 0;
}

.users-header-second__headline {
  display: flex;
  align-items: center;
}

.users-header__searchfield {
  width: 200px;
  height: 28px;
  font-weight: normal;
  border-color: #d8d8d8;
  transition: width .2s;
}

.list {
  height: calc(100% - 50px);
}

.users-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  margin: 0;
}

.users-user {
  display: flex;
  height: 50px;
  align-items: center;
  transition: background-color 0.25s;
}

.users-user:nth-child(odd) {
  background-color: #f8fafb;
}

.users-user.isSelected {
  border-top: 1px solid white;
  background-color: rgba(77, 138, 207, 0.3);
}

.users-img {
  margin-right: 20px;
}

.users-img > img {
  height: 35px;
  border-radius: 4px;
}

.users-user__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  max-width: 480px;
  cursor: pointer;
}

.users-user__meta__selectall {
  padding-left: 20px;
  cursor: pointer;
}

.users-user__meta__selectall:hover {
  color: var(--blue);
}

.sms-standard__sub {
  border: 1px solid #ccc;
  max-width: 33%;
  margin: 20px 0;
  padding: 10px;
}

.receivers-container {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
}

.receivers-container__receiver {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 5px 5px 0;
  border: 1px solid #cccccc;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
}

.receiver__name {
  margin-right: 4px;
}

.receiver__remove {
  cursor: pointer;
}

.receiver__remove:hover {
  color: var(--danger);
}

label {
  color: #a2a3a6;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: .085rem;
}

label.little-label {
  text-transform: initial;
}

.explainer-text {
  font-style: italic;
}

.sms-template {
  display: flex;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #cccccc;
  padding: 0 4px;
  margin-bottom: 5px;
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  transition: border 0.25s, transform 0.5s;
}

.sms-template:hover {
  border-color: var(--blue);
}

.sms-template__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
  transition: transform 0.25s;
  height: 100%;
}

.sms-template__title:active {
  transform: scale(0.98);
}

.button-lookalike {
  border: 1px solid #c0c0c0;
  border-radius: 4px;
  padding: 1px 4px;
  margin-right: 5px;
}

.sms-template > .sms-template__title {
  flex: 1;
  display: flex;
  align-items: center;
}

.sms-template > div > span {
  margin-right: 5px;
}

.user--has-no-active-contact > .users-user__meta {
  opacity: 0.65;
  cursor: default !important;
}

.user--has-no-active-contact .users-choose {
  cursor: default;
}

.subs-without-number {
  position: absolute;
  top: 100%;
  z-index: 12;
  background-color: #222222;
  color: white;
}

.selectedWithoutContactForm.users-user {
  background-color: rgba(250, 86, 90, 0.35);
}

.users-choose--disabled {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.7s ease;
}

.fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(100px);
  opacity: 0;
}


.fadeOut-leave-active {
  transition: all .5s ease-out;
}

.fadeOut-leave-to {
  opacity: 0;
}

.users-phone {
  margin-right: 10px;
}

.users-phone:hover {
  color: var(--blue);
  cursor: pointer;
}

.users-phone__add {
  cursor: pointer;
  font-style: italic;
}

.users-phone__add:hover {
  color: var(--blue);
}

.users-name {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.users-name:hover .edit-number-clicker {
  visibility: visible;
  transform: translateX(-4px);
  opacity: 1;
  pointer-events: auto;
}

.edit-number-clicker {
  visibility: hidden;
  pointer-events: none;
  opacity: 0;
  transition: all 0.25s;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-number-clicker:hover {
  color: var(--blue);
}

.users__last-message {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 11px;
  font-style: italic;
  opacity: 0.45;
  cursor: pointer;
  padding: 0px 4px;
  border-radius: 4px;
  border: 1px solid #eee;
}

.users__last-message:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, .16);
}

.flex {
  display: flex;
  flex-direction: row;
}

.users-last {
  display: flex;
  align-items: center;
  height: 100%;
}

.users-last > div:last-child {
  margin-left: 10px;
}

.send-sms__body__templates {
  padding: 1rem;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 0;
}

.slideInUp-enter-active {
  transition: transform 0.3s cubic-bezier(0.33, 1, 0.68, 1);
}

.slideInUp-enter {
  transform: translateY(100%);
}

.slideInUp-enter-to, .slideInUp-leave {
  transform: translateY(0);
}

.sms-template__create {
  padding: 0.25rem 0.5rem;
  background: transparent !important;
  border: 1px dashed #ccc;
}

.sms-template__create > div > span {
  background-color: #999;
  color: #fff;
  height: 1rem;
  display: flex;
  width: 1rem;
  border-radius: 50%;
  transition: background-color .2s;
  align-items: center;
  justify-content: center;
}

.contact-options {
  display: flex;
  align-items: center;
  height: 100%;
}

.contact-options__option {
  position: relative;
  width: 46px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #d8d8d8;
  font-size: 1.2rem;
}

.contact-options__option.contact-options__option__settings {
  width: 30px;
}

.users-user.users-user__header {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 1rem;
  border-bottom: 1px solid #d8d8d8;
  height: 30px;
}

.users-user.users-user__header .text-link {
  color: #222;
  text-decoration: none;
}

.users-user.users-user__header .text-link:hover {
  color: var(--blue)
}

.users-user__header__right {
  display: flex;
  margin-right: 30px;
}

.users-user__header__right > p {
  width: 46px;
  text-align: center;
  color: #a2a3a6;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: .085rem;
  font-weight: bold;
}

.users-user__header__right > p.last-sms-text {
  width: auto;
  text-align: right;
}

.last-sms-text--click {
  cursor: pointer;
  user-select: none;
}

.users-user.users-user__header > p.users-user__header__settings {
  width: 30px;
  opacity: 0;
}

.d-icon__awaiting-approval {
  stroke: #ee7157;
}

.w-6 {
  width: 1.5rem;
}

.contact-options__option .icon__bg-circle .d-hero-icon--add {
  opacity: 0;
}

.contact-options__option .icon__bg-circle:hover .d-hero-icon--add,
.contact-options__option .icon__bg-circle:hover .d-tw-icon--deactivated {
  opacity: 1;
}

.contact-options__option .icon__bg-circle .d-tw-icon--deactivated {
  opacity: 0.15;
}

.icon__bg-circle.contact-options__option__phone .d-tw-icon--deactivated {
  position: relative;
}

.contact-options__option .icon__bg-circle .d-tw-icon--deactivated + .d-off-sign {
  border-color: #e2e3e5;
}

.contact-options__option .icon__bg-circle .d-tw-icon--deactivated + .d-off-sign .d-off-sign__stroke {
  background: #e2e3e5;
}

.contact-options__option .icon__bg-circle:hover .d-tw-icon--deactivated + .d-off-sign {
  border-color: #ee7157;
}

.contact-options__option .icon__bg-circle:hover .d-tw-icon--deactivated + .d-off-sign .d-off-sign__stroke {
  background: #ee7157;
}

.d-off-sign {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid #ee7157;
  top: 25px;
  left: 22px;
  color: #222222;
  background: #fff;
}

.d-off-sign__stroke {
  position: absolute;
  z-index: 1;
  height: 1px;
  transform: rotate(311deg);
  background: #222222;
  top: 2px;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #222222;
}


.contact-options__option--disabled .icon__bg-circle {
  position: relative;
  border: 1px solid rgb(204 204 204 / 50%);
}

.contact-options__option--disabled .icon__bg-circle:hover {
  border-color: #222222;
}

.contact-options__option--disabled .icon__bg-circle:hover:before {
  background: #222222;
}

.contact-options__option--disabled .icon__bg-circle:before {
  content: '';
  position: absolute;
  z-index: 1;
  height: 1px;
  transform: rotate(311deg);
  background: rgb(204 204 204 / 50%);
  top: 14px;
  left: 0;
  right: 0;
}

.users-header-second__button {
  min-height: 50px;
  flex-wrap: wrap;
  padding: 10px;
  gap: 1rem;
  border: 1px solid #d8d8d8;
  border-width: 0 1px 1px 0;
}

</style>



// WEBPACK FOOTER //
// SendMessages.vue?07d8d0f9